export default __webpack_public_path__ + "locales/sr-Latn-RS/DownloadDialog.json?hash=c791972ea933ce00304dfce11a108b00";